const REDIRECT_STORAGE_KEY = 'SMART_SALES_PRIVATE_QUALITY_REDIRECT'
export const PRIVATE_QUALITY_ENTRY_PATH = '/smartSalesAi/privateQuality'

export function isPrivateQualityEntryPath(path = '') {
  const normalized = String(path || '').split('?')[0]
  return (
    normalized === PRIVATE_QUALITY_ENTRY_PATH ||
    normalized.endsWith('/privateQuality')
  )
}

export function isPrivateQualityRedirect(redirect = '') {
  return isPrivateQualityEntryPath(normalizeRedirectPath(redirect))
}

export function isPrivateQualityRouteItem(item) {
  return (
    item?.meta?.title === '私域质检' ||
    item?.name === 'SmartSalesPrivateQuality' ||
    item?.name === 'SmartSalesPrivateQualityEntry' ||
    item?.component === 'smartSalesAi/privateQuality/index' ||
    (typeof item?.path === 'string' && item.path.includes('privateQuality'))
  )
}

export function normalizeRedirectPath(redirect = '') {
  if (!redirect) return ''
  let value = String(redirect).trim()
  try {
    // 兼容被 encode 一次或多次的情况
    for (let i = 0; i < 2; i++) {
      if (!value.includes('%')) break
      value = decodeURIComponent(value)
    }
  } catch (e) {
    // ignore
  }
  if (value.startsWith('#')) value = value.slice(1)
  if (!value.startsWith('/')) value = `/${value}`
  return value.split('?')[0]
}

export function rememberPrivateQualityRedirect(path = PRIVATE_QUALITY_ENTRY_PATH) {
  const target = normalizeRedirectPath(path) || PRIVATE_QUALITY_ENTRY_PATH
  try {
    sessionStorage.setItem(REDIRECT_STORAGE_KEY, target)
  } catch (e) {
    // ignore
  }
  return target
}

export function clearPrivateQualityRedirect() {
  try {
    sessionStorage.removeItem(REDIRECT_STORAGE_KEY)
  } catch (e) {
    // ignore
  }
}

export function consumePrivateQualityRedirect() {
  try {
    const cached = sessionStorage.getItem(REDIRECT_STORAGE_KEY)
    clearPrivateQualityRedirect()
    return cached ? normalizeRedirectPath(cached) : ''
  } catch (e) {
    return ''
  }
}

export function peekPrivateQualityRedirect() {
  try {
    return normalizeRedirectPath(sessionStorage.getItem(REDIRECT_STORAGE_KEY) || '')
  } catch (e) {
    return ''
  }
}
